<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Vcard',

    metaInfo: { title: 'VirtualBusinessCard' },

    extends: View,

    mixins: [
      LoadSections([
        'vcard',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'virtualcard',
      },
    },
  }
</script>
